export default "/images/vendor/flag-icon-css/flags/4x3/uy.svg?2a4ff395d3b91e6a8d73f70c1a70470d";